module.exports = "<!-- \n<div>\n    <strong>This is footer</strong>\n</div>\n-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = 643
// module chunks = 0